import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef, Input } from '@angular/core';
import { WizDropItemEvent, WIZ_DRAGGABLE_COMPONENT } from '@wizeoo/akm-component-lib';
import { EM_ACTION, FeiKeyDef } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { FormWidgetGridsterComponent } from '../../form/generic/form-widget.gridster.component';
import { FeiVO } from '../../../../vo/workingdata/fei.vo';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { ViewData } from '../../../../model/view.data';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { GridType } from 'angular-gridster2';

@Component({
  selector: 'tile-gridster',
  template: `
  <div class ="wrapper" width="100%" height="100%" [style.background-color]="_backgroundColor" style="padding: 3px;">
    <gridster #gridster [options]="options" width="100%" height="100%" 
    class="gridster" tabindex="0" 
    [style.background-color]="_backgroundColor"
    [style.overflow]="overflow">
      <gridster-item [item]="item" *ngFor="let item of widgets">
        <tile-gridster-item 
        [field]="item" 
        [model]="model"
        [widget]="widget"
        [entity]="entity"
        [templatingMode]="templatingMode"
        (delete)="onItemDeleted($event)"></tile-gridster-item>
      </gridster-item>
    </gridster>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => TileGridsterComponent),
    },
  ],
  styleUrls: ['../../form/generic/form-widget.gridster.component.scss']
})
export class TileGridsterComponent extends FormWidgetGridsterComponent {

  constructor(cdref: ChangeDetectorRef) {
    super(cdref);
  }

  @Input() fei: FeiVO;
  @Input() context: WidgetConfigurationObj;
  @Input() entity: any; // l'objet manipulé (WidgetLine), pour gestion des tiles

  /**
   * @override pour mode de rendu hors template
   */
  public updateOptions() {
    super.updateOptions();
    this.options.gridType = this.templatingMode ? GridType.Fixed : GridType.Fit; //;
  }


  onAddItemAfterDrag(pEvent: WizDropItemEvent): void {

    const pivotField: PivotField = pEvent.item.data;
    // enrichissement du wcio si libellé
    let wcio: WidgetConfigurationItemObj;
    // interception des champs de libellés
    if (pivotField.code === ViewData.FORM_HTML || pivotField.code === ViewData.FORM_IMAGE || pivotField.code === ViewData.FORM_ACTION  ) { // rendu custom sur FD
      wcio = this.model.widgetEngine.newWcio(pivotField.code, 0);
      wcio.lbl = pivotField.fkd.label;
    } else {
      wcio = this.model.widgetEngine.newWcio(pivotField.fullCode, 0);
    }
    

    const item: GridsterWidgetItem = GridsterWidgetItem.constructFromGridster(this.gridster.emptyCell.getValidItemFromEvent(pEvent.event));
    item.field = new FormFieldObj(this.widget, this.fei, wcio); // TODO TODO alimenter widget
    item.source = wcio;
    item.entity = this.entity;
    item.updateCoords();
   
    this._widgets = [item, ...this._widgets];
    // console.log('onAddItemAfterDrag subGridster', item);
    this.widgetsChanged.emit({item, action: EM_ACTION.CREATE}); //this.widgetsChanged.emit(this._widgets);

    this.cdref.markForCheck();
  }

  checkDragOver(event: WizDropItemEvent): boolean {
    this.gridster.emptyCell.emptyCellDragOver(event.event);

    // console.log('drag', event);
    const fkd: FeiKeyDef = event.item.data;
    if (!fkd || fkd.isKey) {
      return true;
    }
    return !this._widgets.find(wo => wo.field.fkd?.fullCode === event.item.data?.fullCode) && event.event.dataTransfer.dropEffect !== 'none';
  }
}
